import Animation from 'animation'

/*
 * Beakers
 */
class BeakerAnimation extends Animation {

  match () {
    return true
  }

  bindAndAnimate (container, node) {
    // TODO We don't animate these yet
  }

}

export default BeakerAnimation
